"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _router = _interopRequireDefault(require("@/router"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'App',
  data: function data() {
    return {
      modeEditCounter: 0,
      message: 'Les modifications que vous avez apportées ne seront peut-être pas enregistrées. Voulez-vous continuer ?'
    };
  },
  mounted: function mounted() {
    var _this = this;

    _eventBus.EventBus.$on('MODE_EDIT', function (modeEdit) {
      _this.modeEditCounter = modeEdit;
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);

    _router.default.beforeEach( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(to, from, next) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.modeEditCounter > 0) {
                  if (!confirm(_this.message)) {
                    next(from);
                  } else {
                    _this.$root.modeEdit = false;
                    _this.modeEditCounter = 0;
                    next();
                  }
                } else {
                  _this.$root.modeEdit = false;
                  _this.modeEditCounter = 0;
                  next();
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());

    _router.default.afterEach(function () {
      _this.$root.modeEdit = false;
    });
  },
  methods: {
    handleBeforeUnload: function handleBeforeUnload(event) {
      if (this.modeEditCounter > 0) {
        if (!confirm(this.message)) {
          event.preventDefault();
          event.returnValue = this.message;
        }

        this.$root.modeEdit = false;
        this.modeEditCounter = 0;
      }
    }
  }
};
exports.default = _default;